<template>
  <b-container
    :fluid="true"
    class="px-0"
    :style="{ margin: (loading || error) ? '0 !important' : 'auto'}"
    v-cloak
  >
    <form @submit.prevent="valid">
      <div v-if="loading" class="min-vh-100 d-flex align-items-center justify-content-center">
        <Loading />
      </div>
      <div v-else-if="error" class="min-vh-100 d-flex align-items-center justify-content-center">
        <div style="max-width: 400px;">
          <h4 class="text-2xl text-gray-500 font-weight-bold">
            Shipment Not Found
          </h4>
          <p class="text-gray-700">
            Shipment with id <span class="badge badge-primary">{{ $route.params.id }}</span> could
            not be found. Make sure that there are no typos in the shipment id.
          </p>
          <b-button
            class="d-flex align-items-center mx-auto"
            @click="$router.go(-1)"
          >
            <b-icon-chevron-left font-scale="0.8" />
            BACK
          </b-button>
        </div>
      </div>
      <b-row v-else class="px-3">
        <b-col
          cols="auto"
          class="pr-0 position-fixed d-none d-md-flex align-items-center"
          style="top: 10px; z-index: 1; height: calc(100vh - 20px);"
        >
          <div>
            <ShipmentNavProgress
              :card-names="cardNamesOrdered"
            ></ShipmentNavProgress>
          </div>
        </b-col>
        <b-col class="col ml-md-5" lg="8" id="content">
          <ShipmentPrototypeCard name="invoice" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>INVOICE #/ CONTAINER #</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <b-row>
                  <b-col class="floating-label-container">
                    <div v-if="$route.params.id">
                      <label class="col-form-label floating-label active" for="Invoice">Invoice #
                      </label>
                      <label class="col-form-label floating-label" for="Invoice">{{ response.id }}
                      </label>
                    </div>
                    <div v-else>
                      <label class="col-form-label floating-label" for="Invoice">Invoice #
                      </label>
                      <input
                        required
                        class="form-control text-center"
                        id="Invoice"
                        name="Invoice"
                        type="text"
                        v-model="response.id"
                      >
                    </div>
                  </b-col>
                  <b-col class="floating-label-container">
                    <div v-if="$route.params.id">
                      <label class="col-form-label floating-label active" for="Container">
                        Container #
                      </label>
                      <label class="col-form-label floating-label" for="Container">
                        {{ response.pickupDetails.container }}
                      </label>
                    </div>
                    <div v-else>
                      <label class="col-form-label floating-label" for="Container">Container #
                      </label>
                      <input
                        required
                        class="form-control text-center"
                        id="Container"
                        name="Container"
                        type="text"
                        v-model="response.pickupDetails.container"
                      >
                    </div>
                 </b-col>
                </b-row>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="sender" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>SENDER</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="shipperFirst">First Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="shipperFirst"
                      name="shipperFirst"
                      type="text"
                      v-model="response.shipper.firstName"
                    >
                  </b-col>

                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="shipperLast">Last Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="shipperLast"
                      name="shipperLast"
                      type="text"
                      v-model="response.shipper.lastName"
                    >
                 </b-col>
                </b-row>

                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="address">Address</label>
                  <input
                    required
                    class="form-control text-center"
                    id="address"
                    name="address"
                    type="text"
                    v-model="response.shipper.address"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="sender-country">Country</label>
                  <input
                    required
                    class="form-control text-center"
                    id="sender-country"
                    name="sender-country"
                    type="text"
                    v-model="response.shipper.country"
                  >
                </div>
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="city">City</label>
                    <input
                      required
                      class="form-control text-center"
                      id="city"
                      name="city"
                      type="text"
                      v-model="response.shipper.city"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="state">State</label>
                    <input
                      required
                      class="form-control text-center"
                      id="state"
                      name="state"
                      type="text"
                      v-model="response.shipper.state"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="zip-code">Zone/Zip Code
                    </label>
                    <input
                      class="form-control text-center"
                      id="zip-code"
                      name="zip-code"
                      type="text"
                      v-model="response.shipper.zipCode"
                    >
                  </b-col>
                </b-row>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="sender-email">Email</label>
                  <input
                    required
                    class="form-control text-center"
                    id="sender-email"
                    name="sender-email"
                    type="email"
                    v-model="response.shipper.email"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="sender-phone">Phone</label>
                  <input
                    required
                    class="form-control text-center"
                    id="sender-phone"
                    name="sender-phone"
                    type="text"
                    v-model="response.shipper.phone"
                  >
                </div>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="consignee" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>CONSIGNEE</h6>
            </template>
            <template v-slot:body>
              <div class="mx-5 pb-3">
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="consigneeFirst">First Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="consigneeFirst"
                      name="consigneeFirst"
                      type="text"
                      v-model="response.consignee.firstName"
                    >
                  </b-col>

                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="consigneeLast">Last Name
                    </label>
                    <input
                      required
                      class="form-control text-center"
                      id="consigneeLast"
                      name="consigneeLast"
                      type="text"
                      v-model="response.consignee.lastName"
                    >
                 </b-col>
                </b-row>

                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label"
                    for="consignee-address"
                  >Address</label>
                  <input
                    required
                    class="form-control text-center"
                    id="consignee-address"
                    name="consignee-address"
                    type="text"
                    v-model="response.consignee.address"
                  >
                </div>
                <div class="floating-label-container">
                  <label
                    class="col-form-label floating-label"
                    for="consignee-country"
                  >Country</label>
                  <input
                    required
                    class="form-control text-center"
                    id="consignee-country"
                    name="consignee-country"
                    type="text"
                    v-model="response.consignee.country"
                  >
                </div>
                <b-row>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="consignee-city">City</label>
                    <input
                      required
                      class="form-control text-center"
                      id="consignee-city"
                      name="consignee-city"
                      type="text"
                      v-model="response.consignee.city"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="consignee-state">State</label>
                    <input
                      required
                      class="form-control text-center"
                      id="consignee-state"
                      name="consignee-state"
                      type="text"
                      v-model="response.consignee.state"
                    >
                  </b-col>
                  <b-col class="floating-label-container">
                    <label class="col-form-label floating-label" for="consignee-zipcode">
                      Zone/Zip Code
                    </label>
                    <input
                      class="form-control text-center"
                      id="consignee-zipcode"
                      name="consignee-zipcode"
                      type="text"
                      v-model="response.consignee.zipCode"
                    >
                  </b-col>
                </b-row>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="consignee-email">Email</label>
                  <input
                    required
                    class="form-control text-center"
                    id="consignee-email"
                    name="consignee-email"
                    type="email"
                    v-model="response.consignee.email"
                  >
                </div>
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="consignee-phone">Phone</label>
                  <input
                    required
                    class="form-control text-center"
                    id="consignee-phone"
                    name="consignee-phone"
                    type="text"
                    v-model="response.consignee.phone"
                  >
                </div>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="pickup" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6 class="flex-grow-1 text-center">PICKUP DETAILS</h6>
            </template>
            <template v-slot:body>
              <div class="mx-1 mx-md-5">
                <div class="floating-label-container">
                  <label class="col-form-label floating-label" for="pickup-driver">
                    Pickup Driver
                  </label>
                  <input
                    required
                    class="form-control text-center"
                    id="pickup-driver"
                    name="pickup-driver"
                    type="text"
                    v-model="response.pickupDetails.driver"
                  >
                </div>
                <div class="shipment-list-item px-3">
                  <div class="text-muted">
                    PICKUP TIME
                  </div>
                  <div>
                    <div class="d-inline-block">
                      <b-form-datepicker
                        required
                        reset-button
                        v-model="response.pickupDetails.pickupStartTime"
                        class="normalize text-center"
                        :max="maxStartDate"
                        :state="isStartDateValid"
                      ></b-form-datepicker>
                    </div>
                    <div class="d-inline-block">
                      <b-form-timepicker
                        required
                        reset-button
                        v-model="pickupStartTime"
                        class="normalize"
                        locale="en"
                        :state="isStartTimeValid"
                      ></b-form-timepicker>
                    </div>
                  </div>
                  <p>-</p>
                  <div>
                    <div class="d-inline-block">
                      <b-form-datepicker
                        required
                        reset-button
                        v-model="response.pickupDetails.pickupEndTime"
                        class="normalize text-center"
                        :min="minEndDate"
                        :state="isEndDateValid"
                      ></b-form-datepicker>
                    </div>
                    <div class="d-inline-block">
                      <b-form-timepicker
                        required
                        reset-button
                        v-model="pickupEndTime"
                        class="normalize"
                        locale="en"
                        :state="isEndTimeValid"
                      ></b-form-timepicker>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center">
                  <b-btn
                    variant="outline-dark"
                    class="text-xs mx-2"
                    @click="visiblePickupNote = !visiblePickupNote"
                  >
                    {{ noteStatus }} Note
                  </b-btn>
                </div>
                <b-collapse
                  :id="'pickup-note-button'"
                  :visible="visiblePickupNote"
                  ref="pickup-note-collapse"
                >
                  <div class="d-flex justify-content-center mt-2">
                    <div style="width: 100%;" ref="pickupInstructions">
                      <b-form-textarea
                        id="delivery-notes"
                        v-model="response.pickupDetails.pickupNote"
                        rows="1"
                        max-rows="6"
                        style="width: 90%; margin: auto; border: 2px solid lightgray;
                           border-radius: 5px;"
                      ></b-form-textarea>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="items" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <div class="position-relative d-flex justify-content-center align-items-center">
                <div
                  class="dropdown position-absolute left-15"
                  :class="{show: flagDropdownVisible}"
                >
                  <button
                    class="btn btn-secondary dropdown-toggle rounded-pill text-xs mx-2"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    :aria-expanded="flagDropdownVisible"
                    @click.stop="flagDropdownVisible = !flagDropdownVisible"
                  >
                    <b-icon-flag-fill
                      :style="{
                        color: response.itemDetails.flag ?
                         flagColor[response.itemDetails.flag] : '#eeeeee',
                        }"
                    ></b-icon-flag-fill>
                  </button>
                  <div
                    class="dropdown-menu text-xs border-0 shadow-lg"
                    :class="{show: flagDropdownVisible}"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <b-dropdown-item
                      link-class="d-flex justify-content-between align-items-center px-3"
                      @click.stop="() => {
                        response.itemDetails.flag = (response.itemDetails.flag === 'delayed'
                          ? ''
                          : 'delayed');
                        flagDropdownVisible = false;
                      }"
                    >
                      <div>
                        <b-icon-flag-fill
                          style="color: #d476fd"
                        ></b-icon-flag-fill>
                        Delayed
                      </div>
                      <b-icon-check v-if="response.itemDetails.flag === 'delayed'"></b-icon-check>
                    </b-dropdown-item>
                    <b-dropdown-item
                      link-class="d-flex justify-content-between align-items-center px-3"
                      @click.stop="() => {
                        response.itemDetails.flag = (response.itemDetails.flag === 'pickup'
                          ? ''
                          : 'pickup');
                        flagDropdownVisible = false;
                      }"
                    >
                      <div>
                        <b-icon-flag-fill
                          style="color: #f1c32b"
                        ></b-icon-flag-fill>
                        Pick Up Error
                      </div>
                      <b-icon-check v-if="response.itemDetails.flag === 'pickup'"></b-icon-check>
                    </b-dropdown-item>
                    <b-dropdown-item
                      link-class="d-flex justify-content-between align-items-center px-3"
                      @click.stop="() => {
                        response.itemDetails.flag = (response.itemDetails.flag === 'other'
                          ? ''
                          : 'other');
                        flagDropdownVisible = false;
                      }"
                    >
                      <div>
                        <b-icon-flag-fill
                          style="color: #8abdd0"
                        ></b-icon-flag-fill>
                        Other Error
                      </div>
                      <b-icon-check v-if="response.itemDetails.flag === 'other'"></b-icon-check>
                    </b-dropdown-item>
                  </div>
                </div>
                <h6>ITEMS</h6>
              </div>
            </template>
            <template v-slot:body>
              <ShipmentPrototypeItemList
                :items="response.itemDetails.items"
                @add="addNewItem"
                @remove="removeItem"
                @toggleHazard="toggleHazard"
              ></ShipmentPrototypeItemList>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="charges" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>CHARGES</h6>
            </template>
            <template v-slot:body>
              <hr/>
              <div style="max-width: 20%;" class="my-3 mx-3">
                <b-form-select
                  required
                  id="delivery-type"
                  v-model="response.itemDetails.shippingTerm"
                  :options="deliveryTypes"
                  class="text-center"
                ></b-form-select>
              </div>
              <ShipmentPrototypeChargesList
                :items="response.chargeDetails.charges"
                @add="addNewCharge"
                @remove="removeCharge"
              ></ShipmentPrototypeChargesList>
              <hr class="my-0">
              <b-button
                variant="outline-dark"
                class="mt-3 text-xs"
                @click="addNewCharge()"
              >
                Add Charge
              </b-button>
            </template>
          </ShipmentPrototypeCard>
          <ShipmentPrototypeCard name="payments" v-observe-visibility="visibilityChanged">
            <template v-slot:title>
              <h6>PAYMENTS</h6>
            </template>
            <template v-slot:body>
              <ShipmentPrototypePaymentList
                :items="response.payments"
                @add="addNewPayment"
                @remove="removePayment"
              ></ShipmentPrototypePaymentList>
            </template>
          </ShipmentPrototypeCard>
          <div v-if="$route.params.id">
            <ShipmentPrototypeCard name="update" v-observe-visibility="visibilityChanged">
                <template v-slot:title>
                  <h6>FINAL STEP</h6>
                </template>
                <template v-slot:body>
                  <b-button type="update" block class="mb-2 shipment-create-button w-50 m-auto">
                    <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
                    UPDATE SHIPMENT
                  </b-button>
                </template>
              </ShipmentPrototypeCard>
          </div>
          <div v-else>
             <ShipmentPrototypeCard name="submit" v-observe-visibility="visibilityChanged">
                <template v-slot:title>
                  <h6>FINAL STEP</h6>
                </template>
                <template v-slot:body>
                  <b-button type="submit" block class="mb-2 shipment-create-button w-50 m-auto">
                    <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
                    CREATE SHIPMENT
                  </b-button>
                </template>
              </ShipmentPrototypeCard>
          </div>

        </b-col>
        <b-col col class="h-100 position-sticky d-none d-lg-block" style="top: 10px;">
  <!--   :href="'/search?' + 'accountNumber=' + accountNumber + '&name=' + name + '&phoneNumber='-->
  <!--    + phoneNumber + '&destination=' + destination + '&bol=' + bol"-->
          <div>
            <b-button
              v-if="backToSearch"
              variant="secondary"
              block
              class="mb-3"
              @click="$router.go(-1)"
            >
              <h5 class="text-light">
                <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
                <span class="ml-3">BACK</span>
              </h5>
            </b-button>
            <ShipmentPrototypeCard name="summary" :collapsible="false">
              <template v-slot:title>
                <h6 class="font-weight-bold">SUMMARY</h6>
              </template>
              <template v-slot:body>
                <hr class="mt-0 mb-2"/>
                <div v-if="response.shipper.firstName && response.consignee.firstName">
                  <div class="text-sm text-muted">
                    <span>Sender</span>
                    <b-icon-arrow-right-short></b-icon-arrow-right-short>
                    <span>Consignee</span>
                  </div>
                  <mark><b>{{ `${response.shipper.firstName} ${response.shipper.lastName}` }}</b>
                  </mark>
                  <b-icon-arrow-right-short></b-icon-arrow-right-short>
                  <mark><b>{{ `${response.consignee.firstName} ${response.consignee.lastName}` }}
                  </b></mark>
                  <hr class="my-2"/>
                </div>
                <div v-if="totalCount > 0">
                  <div>
                    <b-icon-box-seam class="mr-2"></b-icon-box-seam>{{ mostCommonReference }}
                  </div>
                  <div style="font-size: smaller;">
                    {{ totalCount }} <b-icon-x></b-icon-x> items
                    <b-icon-dot></b-icon-dot>
                    {{ totalWeight }} lbs
                    <b-icon-dot></b-icon-dot>
                    {{ totalVolume }} in<sup>3</sup>
                  </div>
                  <hr class="my-2"/>
                </div>
                <div>
                  <div class="text-xs text-muted">Booked Date</div>
                    <div v-if="$route.params.id">
                      {{ dateCreated }}
                  </div>
                  <div v-else>
                    {{ currentDateTime() }}
                  </div>
                </div>
                <div
                  v-if="response.pickupDetails.pickupStartTime
                    && response.pickupDetails.pickupEndTime"
                >
                  <hr class="my-2"/>
                  <ShipmentPrototypeCard
                    name="status"
                    class="m-0"
                    :visible="false"
                    style="box-shadow: none !important;"
                  >
                    <template v-slot:title>
                      <div class="text-wrap px-5">
                        <div class="text-xs text-muted">
                          Pickup Time
                        </div>
                        <div class="d-flex justify-content-center">
                          <div>{{ formattedPickupStart }}</div>
                          <b-icon-dot></b-icon-dot>
                          <div>{{ formattedPickupEnd }}</div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:body>
                      <div class="mx-3">
                        <hr class="mx-4 my-0"/>
                        <ShipmentStatusProgress
                          :current-status="response.movementStatus"
                        ></ShipmentStatusProgress>
                      </div>
                    </template>
                  </ShipmentPrototypeCard>
                </div>
                <hr class="my-2"/>
                <div>
                  <div class="text-xs text-muted">
                    Outstanding balance
                  </div>
                  ${{ outstandingBalance }}
                </div>
              </template>
            </ShipmentPrototypeCard>
            <div v-if="$route.params.id">
              <b-button type="update" block class="shadow-sm mb-2 shipment-create-button">
                <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
                UPDATE SHIPMENT
              </b-button>
            </div>
            <div v-else>
              <b-button type="submit" block class="shadow-sm mb-2 shipment-create-button">
                <b-icon-file-earmark-plus class="mr-2"></b-icon-file-earmark-plus>
                CREATE SHIPMENT
              </b-button>
            </div>
            <div class="d-inline-flex mt-2">
              <b-button @click="reset" class="shipment-option" title="New Shipment">
                <b-icon-plus></b-icon-plus>
              </b-button>
              <b-button @click="copy" class="shipment-option" title="Copy to New">
                <b-icon-files></b-icon-files>
              </b-button>
              <b-button
                v-b-modal.print
                class="shipment-option"
                title="Print"
              >
                <b-icon-printer></b-icon-printer>
              </b-button>

               <b-modal id="print" ref="printModal" title="Shipment Files" hide-footer>
                  <b-button
                    block class="shadow-sm mb-2 shipment-create-button"
                    @click="hideModal($refs.pdf1);"
                    title="BillOfLading"
                  >
                    Bill of Lading
                  </b-button>
                  <b-button
                    block class="shadow-sm mb-2 shipment-create-button"
                    @click="hideModal($refs.pdf2);"
                    title="invoice"
                  >
                    Invoice
                  </b-button>
              </b-modal>

              <b-modal id="confirmation" ref="confirmationModal" centered title="" hide-footer
              hide-header>
                <div v-if="processing">
                  <Loading />
                </div>
                <div v-else-if="processingError">
                  <div class="d-flex align-items-center justify-content-center">
                    <Cross />
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <h2>Failure</h2>
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    {{ processingError }}
                  </div>
                </div>
                <div v-else>
                  <div class="d-flex align-items-center justify-content-center">
                    <Checkmark />
                  </div>
                  <div class="d-flex align-items-center justify-content-center">
                    <h2>Done!</h2>
                  </div>
                </div>
              </b-modal>
            </div>
          </div>
        </b-col>
      </b-row>
    </form>
    <PrintBillOfLading name="html2Pdf" :response="response" ref="pdf1" />
    <PdfTest name="html2Pdf" :response="response" ref="pdf2" />
  </b-container>
</template>

<script>
import _ from 'lodash';
import { nanoid } from 'nanoid';

import ShipmentPrototypeCard from '../components/ShipmentPrototypeCard.vue';
import ShipmentPrototypeItemList from '../components/ShipmentPrototypeItemList.vue';
import ShipmentPrototypeChargesList from '../components/ShipmentPrototypeChargesList.vue';
import ShipmentPrototypePaymentList from '../components/ShipmentPrototypePaymentList.vue';
import ShipmentStatusProgress from '../components/ShipmentStatusProgress.vue';
import ShipmentNavProgress from '../components/ShipmentNavProgress.vue';
import Loading from '../components/Loading.vue';
import Checkmark from '../components/Checkmark.vue';
import Cross from '../components/Cross.vue';
import { getShipmentById, postShipment, updateShipment } from '../api/shipment';
import PdfTest from '../components/PdfTest.vue';
import PrintBillOfLading from '../components/PrintBillOfLading.vue';

export default {
  name: 'ShipmentPrototype',
  data() {
    return this.initialState();
  },
  computed: {
    noteStatus() {
      if (this.visiblePickupNote === false) {
        if (this.response.pickupNote === '') {
          return 'Add';
        }
        return 'Show';
      }
      return 'Save';
    },
    cardNamesOrdered() {
      return Object.values(this.cardNames).sort((a, b) => a.order - b.order);
    },
    mostCommonReference() {
      const counter = {};
      this.response.itemDetails.items.forEach((elem) => {
        if (elem.description in counter) {
          counter[elem.description] += 1;
        } else {
          counter[elem.description] = 1;
        }
      });

      let max = -1;
      let maxRef = '';
      Object.entries(counter).forEach(([key, val]) => {
        if (val >= max) {
          maxRef = key;
          max = val;
        }
      });
      return max === -1 ? '' : `${maxRef}...`;
    },
    totalCount() {
      return this.response.itemDetails.items.length;
    },
    totalWeight() {
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.weight, 0);
    },
    totalVolume() {
      return this.response.itemDetails.items.reduce((acc, curr) => acc + curr.volume, 0);
    },
    outstandingBalance() {
      return this.response.chargeDetails.charges.reduce((acc, curr) => acc + curr.amount, 0)
        - this.response.payments.reduce((acc, curr) => acc + curr.amount, 0);
    },
    backToSearch() {
      return this.accountNumber || this.phoneNumber || this.name || this.destination;
    },
    formattedPickupStart() {
      return this.response.pickupDetails.pickupStartTime.toLocaleString('en-US', { timeStyle: 'short' });
    },
    formattedPickupEnd() {
      return this.response.pickupDetails.pickupEndTime.toLocaleString('en-US', { timeStyle: 'short' });
    },
    minEndDate() {
      return this.response.pickupDetails.pickupStartTime;
    },
    maxStartDate() {
      return this.response.pickupDetails.pickupEndTime;
    },
    // isStartDateValid() {
    //   return this.response.pickupDetails.pickupStartTime !== '';
    // },
    // isEndDateValid() {
    //   return this.response.pickupDetails.pickupEndTime !== '';
    // },
    // () {
    //   return this.pickupStartTime !== '';
    // },
    // isEndTimeValid() {
    //   return this.pickupEndTime !== '';
    // },
  },
  methods: {
    initialState() {
      return {
        id: '',
        pickupStartTime: null,
        pickupEndTime: null,
        dateCreated: '',
        isStartDateValid: null,
        isEndDateValid: null,
        isStartTimeValid: null,
        isEndTimeValid: null,
        response: {
          shipper: {
            firstName: '',
            lastName: '',
            address: '',
            country: '',
            city: '',
            state: '',
            zipCode: '',
            email: '',
            phone: '',
          },
          consignee: {
            firstName: '',
            lastName: '',
            address: '',
            country: '',
            city: '',
            state: '',
            zipCode: '',
            email: '',
            phone: '',
          },
          pickupDetails: {
            driver: '',
            pickupStartTime: null,
            pickupEndTime: null,
            pickupNote: '',
            container: '',
          },
          itemDetails: {
            flag: '',
            shippingTerm: null,
            items: [
              {
                id: 0,
                packageType: '',
                description: '',
                weight: 0,
                volume: 0,
                length: 0,
                width: 0,
                height: 0,
                seal: '',
                hazardous: false,
                flag: true,
                selectedWeightType: 'lbs',
                optionsWeightType: [
                  { value: 'lbs', text: 'lbs' },
                  { value: 'kgs', text: 'kgs' },
                  { value: 'tons', text: 'tons' },
                ],
                selectedVolumeType: 'in3',
                optionsVolumeType: [
                  { value: 'in3', text: 'in3' },
                  { value: 'm3', text: 'meters3' },
                ],
                selectedMeasureType: 'in',
                optionsMeasureType: [
                  { value: 'in', text: 'in' },
                  { value: 'm', text: 'meters' },
                ],
              },
            ],
          },
          chargeDetails: {
            charges: [
              {
                id: 0,
                name: 'Freight',
                amount: 0,
                flag: true,
              },
              {
                id: 1,
                name: 'Pickup',
                amount: 0,
                flag: true,
              },
              {
                id: 2,
                name: 'Handling',
                amount: 0,
                flag: true,
              },
              {
                id: 3,
                name: 'Insurance',
                amount: 0,
                flag: true,
              },
            ],
          },
          payments: [],
          movementStatus: '',
        },
        flagDropdownVisible: false,
        visiblePickupNote: false,
        accountNumber: '',
        bol: '',
        phoneNumber: '',
        name: '',
        destination: '',
        print: false,
        loading: true,
        processing: false,
        processingError: '',
        error: false,
        loadingPdf: true,
        deliveryTypes: [
          { value: null, text: 'Delivery Type' },
          { value: 'portToPort', text: 'port to port' },
          { value: 'preClearance', text: 'pre-clearance' },
          { value: 'doorToDoor', text: 'door to door' },
          { value: 'doorToWarehouse', text: 'door to warehouse' },
          { value: 'doorToPort', text: 'door to port' },
        ],
        flagColor: {
          delayed: '#d476fd',
          pickup: '#f1c32b',
          other: '#8abdd0',
        },
        cardNames: {
          invoice: {
            order: 0,
            title: 'Invoice',
            id: 'invoice',
            visible: false,
          },
          sender: {
            order: 1,
            title: 'Sender',
            id: 'sender',
            visible: false,
          },
          consignee: {
            order: 2,
            title: 'Consignee',
            id: 'consignee',
            visible: false,
          },
          pickup: {
            order: 3,
            title: 'Pickup Details',
            id: 'pickup',
            visible: false,
          },
          items: {
            order: 4,
            title: 'Items',
            id: 'items',
            visible: false,
          },
          charges: {
            order: 5,
            title: 'Charges',
            id: 'charges',
            visible: false,
          },
          payments: {
            order: 6,
            title: 'Payments',
            id: 'payments',
            visible: false,
          },
          submit: {
            order: 7,
            title: 'Create Shipment',
            id: 'submit',
            visible: false,
          },
        },
      };
    },
    reset() {
      Object.assign(this.$data, this.initialState());
      delete this.$route.params.id;
      window.history.pushState({}, null, '#/shipment');
      this.loading = false;
    },
    copy() {
      const copy = this.$data.response;
      Object.assign(this.$data, this.initialState());
      this.response.shipper = copy.shipper;
      this.response.consignee = copy.consignee;
      this.response.pickupDetails.driver = copy.pickupDetails.driver;
      this.response.itemDetails.items = copy.itemDetails.items;
      delete this.$route.params.id;
      window.history.pushState({}, null, '#/shipment');
      this.loading = false;
    },
    hideModal(file) {
      this.$refs.printModal.hide();
      file.generatePdf();
    },
    currentDateTime() {
      const today = new Date();

      return today.toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' });
    },
    visibilityChanged(isVisible, entry) {
      if (Object.prototype.hasOwnProperty.call(this.cardNames, entry.target.id)) {
        this.cardNames[entry.target.id].visible = isVisible;
      }
    },
    addNewItem() {
      this.response.itemDetails.items.push({
        id: nanoid(6),
        packageType: '',
        description: '',
        weight: 0,
        volume: 0,
        length: 0,
        height: 0,
        width: 0,
        seal: '',
        hazardous: false,
        flag: true,
        selectedWeightType: 'lbs',
        optionsWeightType: [
          { value: 'lbs', text: 'lbs' },
          { value: 'kgs', text: 'kgs' },
          { value: 'tons', text: 'tons' },
        ],
        selectedVolumeType: 'in3',
        optionsVolumeType: [
          { value: 'in3', text: 'in3' },
          { value: 'm3', text: 'meters3' },
        ],
        selectedMeasureType: 'in',
        optionsMeasureType: [
          { value: 'in', text: 'in' },
          { value: 'm', text: 'meters' },
        ],
      });
    },
    removeItem(id) {
      // this.response.itemDetails.items.splice(
      //   this.response.itemDetails.items.findIndex((item) => item.id === id),
      //   1,
      // );
      this.response.itemDetails.items.find(
        (item) => item.id === id,
      ).flag = false;
    },
    addNewCharge() {
      this.response.chargeDetails.charges.push({
        id: `charge-${nanoid(6)}`,
        amount: 0,
        name: '',
        flag: true,
      });
    },
    removeCharge(id) {
      // this.response.chargeDetails.charges.splice(
      //   this.response.chargeDetails.charges.findIndex((item) => item.id === id),
      //   1,
      // );
      this.response.chargeDetails.charges.find(
        (item) => item.id === id,
      ).flag = false;
    },
    addNewPayment() {
      this.response.payments.push({
        id: `payment-${nanoid(6)}`,
        amount: 0,
        date: '',
        flag: true,
      });
    },
    removePayment(id) {
      // this.response.payments.splice(
      //   this.response.payments.findIndex((item) => item.id === id),
      //   1,
      // );
      this.response.payments.find(
        (item) => item.id === id,
      ).flag = false;
    },
    toggleHazard(idx) {
      const item = this.response.itemDetails.items.find((elem) => elem.id === idx);
      item.hazardous = !item.hazardous;
    },
    createShipment() {
      this.processing = true;
      this.processingError = false;
      this.$refs.confirmationModal.show();
      const copy = JSON.parse(JSON.stringify(this.response));
      delete copy.movementStatus;
      copy.itemDetails.shippingTerm = _.lowerCase(copy.itemDetails.shippingTerm);
      copy.pickupDetails.pickupStartTime = `${copy.pickupDetails.pickupStartTime} ${this.pickupStartTime}`;
      copy.pickupDetails.pickupEndTime = `${copy.pickupDetails.pickupEndTime} ${this.pickupEndTime}`;
      copy.itemDetails.items = copy.itemDetails.items.map(({ id, ...rest }) => rest);
      copy.chargeDetails.charges = copy.chargeDetails.charges.map(({ id, ...rest }) => rest);
      copy.payments = copy.payments.map(({ id, date, ...rest }) => rest);
      copy.shipper = Object.fromEntries(Object.entries(copy.shipper)
        .map(([k, v]) => [k, v.trim()]));
      copy.consignee = Object.fromEntries(Object.entries(copy.consignee)
        .map(([k, v]) => [k, v.trim()]));
      copy.itemDetails.items = copy.itemDetails.items.map(
        ({
          optionsWeightType, optionsVolumeType, optionsMeasureType, ...rest
        }) => rest,
      );

      copy.itemDetails.items = copy.itemDetails.items.map((item) => (
        Object.assign(item,
          {
            packageType: item.packageType.trim(),
            description: item.description.trim(),
            seal: item.seal.trim(),
          })
      ));

      copy.chargeDetails.charges = copy.chargeDetails.charges.map((item) => (
        Object.assign(item,
          {
            name: item.name.trim(),
          })
      ));
      copy.pickupDetails.driver = copy.pickupDetails.driver.trim();

      const data = { data: { ...copy } };
      postShipment(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          this.processing = false;
          setTimeout(() => this.$refs.confirmationModal.hide(), 2000);
          this.$router.push(`/shipment/${resp.data.id}`);
        }).catch((err) => {
          this.processingError = err.response.data.error;
          this.processing = false;
        });
    },
    updateShipment() {
      this.processing = true;
      this.processingError = false;
      this.$refs.confirmationModal.show();
      const copy = JSON.parse(JSON.stringify(this.response));
      delete copy.movementStatus;
      copy.itemDetails.shippingTerm = _.lowerCase(copy.itemDetails.shippingTerm);
      copy.pickupDetails.pickupStartTime = `${copy.pickupDetails.pickupStartTime} ${this.pickupStartTime}`;
      copy.pickupDetails.pickupEndTime = `${copy.pickupDetails.pickupEndTime} ${this.pickupEndTime}`;
      // copy.itemDetails.items = copy.itemDetails.items.map(({ id, ...rest }) => rest);
      // copy.chargeDetails.charges = copy.chargeDetails.charges.map(({ id, ...rest }) => rest);
      // copy.payments = copy.payments.map(({ id, date, ...rest }) => rest);
      copy.shipper = Object.fromEntries(Object.entries(copy.shipper)
        .map(([k, v]) => [k, v.trim()]));
      copy.consignee = Object.fromEntries(Object.entries(copy.consignee)
        .map(([k, v]) => [k, v.trim()]));

      copy.itemDetails.items = copy.itemDetails.items.map((item) => (
        Object.assign(item,
          {
            packageType: item.packageTypetrim(),
            description: item.description.trim(),
            seal: item.seal.trim(),
          })
      ));

      copy.chargeDetails.charges = copy.chargeDetails.charges.map((item) => (
        Object.assign(item,
          {
            name: item.name.trim(),
          })
      ));
      copy.pickupDetails.driver = copy.pickupDetails.driver.trim();

      const data = { data: { ...copy, shipmentId: this.$route.params.id } };
      updateShipment(data)
        .then((resp) => {
          console.log('Successfully POSTed');
          console.log(resp);
          this.processing = false;
          setTimeout(() => this.$refs.confirmationModal.hide(), 2000);
          setTimeout(() => this.$router.go(0), 1000);
        }).catch((err) => {
          this.processingError = err.response.data.error;
          this.processing = false;
        });
    },
    valid() {
      // if (!/^[a-zA-Z]+ [a-zA-Z]+$/.test(this.response.shipper.name)) {
      //   console.log('First Name and Last Name required.');
      // }
      // if (!/^[a-zA-Z]+ [a-zA-Z]+$/.test(this.response.consignee.name)) {
      //   console.log('First Name and Last Name required.');
      // }
      let flag = false;

      this.isStartDateValid = this.response.pickupDetails.pickupStartTime !== '' ? null : false;
      if (this.isStartDateValid === false) {
        flag = true;
      }

      this.isEndDateValid = this.response.pickupDetails.pickupEndTime !== '' ? null : false;
      if (this.isEndDateValid === false) {
        flag = true;
      }

      this.isStartTimeValid = this.pickupStartTime !== '' ? null : false;
      if (this.isStartTimeValid === false) {
        flag = true;
      }
      this.isEndTimeValid = this.pickupEndTime !== '' ? null : false;
      if (this.isEndTimeValid === false) {
        flag = true;
      }

      const charge = this.response.chargeDetails.charges.reduce(
        (partialSum, a) => partialSum + a.amount, 0,
      );
      const payment = this.response.payments.reduce(
        (partialSum, a) => partialSum + a.amount, 0,
      );

      if (payment > charge) {
        flag = true;
        this.processingError = 'There is an overpayment; check charges/payment amount';
        this.$refs.confirmationModal.show();
      }

      if (flag) {
        return;
      }

      if (this.$route.params.id) {
        this.updateShipment();
      } else {
        this.createShipment();
      }
    },
  },
  watch: {
    $route(to, from) {
      const toDepth = to.path.split('/').length;
      const fromDepth = from.path.split('/').length;
      if (toDepth < fromDepth) {
        this.reset();
      }
    },
  },
  mounted() {
    this.initFormlessFloatingLabels();

    this.accountNumber = this.$route.query.accountNumber === undefined ? '' : this.$route.query.accountNumber;
    this.bol = this.$route.query.bol === undefined ? '' : this.$route.query.bol;
    this.phoneNumber = this.$route.query.phoneNumber === undefined ? '' : this.$route.query.phoneNumber;
    this.name = this.$route.query.name === undefined ? '' : this.$route.query.name;
    this.destination = this.$route.query.destination === undefined ? '' : this.$route.query.destination;

    if (this.$route.params.id) {
      getShipmentById(this.$route.params.id)
        .then((res) => {
          console.log(res);
          this.response = res.data.result;
          // Patch types from response
          this.response.payments = this.response.payments.map((p) => ({
            ...p,
            paidDate: new Date(p.paidDate).toISOString().split('T')[0],
            amount: +p.amount,
          }));
          this.response.pickupDetails.pickupEndTime = new Date(
            this.response.pickupDetails.pickupEndTime,
          );
          this.response.pickupDetails.pickupStartTime = new Date(
            this.response.pickupDetails.pickupStartTime,
          );
          this.response.chargeDetails.charges = this.response.chargeDetails.charges
            .map((charge) => ({
              ...charge,
              amount: +charge.amount,
            }));
          // eslint-disable-next-line prefer-destructuring
          this.pickupStartTime = this.response.pickupDetails.pickupStartTime.toLocaleTimeString(
            'en',
            { hour12: false, timeZone: 'UTC' },
          );
          // eslint-disable-next-line prefer-destructuring
          this.pickupEndTime = this.response.pickupDetails.pickupEndTime.toLocaleTimeString(
            'en',
            { hour12: false, timeZone: 'UTC' },
          );
          // eslint-disable-next-line prefer-destructuring
          this.response.pickupDetails.pickupStartTime = this.response.pickupDetails.pickupStartTime
            .toISOString().split('T')[0];
          // eslint-disable-next-line prefer-destructuring
          this.response.pickupDetails.pickupEndTime = this.response.pickupDetails.pickupEndTime
            .toISOString().split('T')[0];
          this.dateCreated = new Date(this.response.pickupDetails.dateCreated).toLocaleString('en-US', { dateStyle: 'short', timeStyle: 'short' });
          // this.response.itemDetails.shippingTerm = this.response.itemDetails.type;
          // delete this.response.itemDetails.type;
          // Fix mismatching enum response
          this.response.itemDetails.shippingTerm = this.response.itemDetails.shippingTerm === 'moved' ? _.camelCase('door to door') : _.camelCase(this.response.itemDetails.shippingTerm);
          this.response.movementStatus = this.response.movement_status;
          delete this.response.movement_status;
          // Fill missing API values
          this.response.itemDetails.items = this.response.itemDetails.items.map((item) => ({
            ...item,
            packageType: item.packageType,
            hazardous: !!item.hazardous,
            selectedWeightType: 'lbs',
            optionsWeightType: [
              { value: 'lbs', text: 'lbs' },
              { value: 'kgs', text: 'kgs' },
              { value: 'tons', text: 'tons' },
            ],
            selectedVolumeType: 'in3',
            optionsVolumeType: [
              { value: 'in3', text: 'in3' },
              { value: 'm3', text: 'meters3' },
            ],
            selectedMeasureType: 'in',
            optionsMeasureType: [
              { value: 'in', text: 'in' },
              { value: 'm', text: 'meters' },
            ],
          }));
          // Correct typo in response
          this.response.movementStatus = this.response.movementStatus === 'Delivering' ? 'Shipping' : this.response.movementStatus;
          this.loading = false;
          this.error = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.error = true;
        });
    } else {
      this.loading = false;
      this.error = false;
    }
  },
  components: {
    PdfTest,
    PrintBillOfLading,
    Loading,
    Checkmark,
    ShipmentNavProgress,
    ShipmentStatusProgress,
    ShipmentPrototypePaymentList,
    ShipmentPrototypeItemList,
    ShipmentPrototypeChargesList,
    ShipmentPrototypeCard,
    Cross,
  },
};
</script>

<style scoped lang="scss">
@import '../assets/styles/floatingLabel.scss';

#pdf {
  width: 100%;
  height: 100%;
}

.shipment-option {
  height: 3em;
  width: 3em;
  padding: 0;
  border-radius: 50%;
  margin: 0 10px;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  background: #7da3c7;
  outline: none;
  border: none;
}

.shipment-option:hover {
  background: #608cb3;
}

.shipment-create-button {
  background: #7da3c7;
  border: none;
}

.shipment-create-button:hover {
  background: #608cb3;
}

.normalize {
  outline: none;
  box-shadow: none;
  background-color: transparent;
  border: none;
  padding-left: 0;
  padding-right: 0;
}

.normalize:focus, .normalize:active {
  outline: none;
  box-shadow: none !important;
  background-color: transparent !important;
  border: none;
}

.shipment-list-item {
  padding: 10px 0;
  color: #4c4c4c;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.shipment-list-item:hover {
  background: #f5f5f5;
  border-radius: 0;
}

h6, h5 {
  margin-bottom: 0;
}

#shipment-scrollspy li {
  position: relative;
}

#shipment-scrollspy li:after {
  content: '.';
  display: block;
  position: absolute;
  top: 0.35em;
  right: 5px;
}

[v-cloak] {
  display: none;
}

::v-deep .b-time {
  width: 100%;
}
</style>

<style>
html {
  scroll-behavior: smooth;
}

.left-15 {
  left: 15px;
}
</style>
